export default __webpack_public_path__ + "img/f4a867eef24aea7798bfa13065b3e9b5.png";